export const OWNER_ROLE_VALUE = '__project_owner__';

export function buildProjectRoleValues(projectRoles, translate) {
    if (!Array.isArray(projectRoles)) {
        return [];
    }

    return [
        {
            label: translate('project.owner'),
            value: OWNER_ROLE_VALUE,
        },
        {
            label: translate('project.no-role'),
            value: null,
        },
        ...projectRoles.map((role) => ({
            value: role.id,
            label: role.name,
        })),
    ];
}
